// Attribution: https://github.com/Azure-Samples/ms-identity-javascript-react-tutorial

// Dependencies
import React from "react";

// Components
import { Notifications } from "./Notifications";
import { StickyFooter } from "./StickyFooter";
import DashboardLayout from "./DashboardSidebar/DashboardLayout";

interface PageLayoutProps {
  fixedHeader?: boolean;
  children?: React.ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  fixedHeader = false,
  children,
}) => (
  <>
    <Notifications />
    <DashboardLayout fixedHeader={fixedHeader}>{children}</DashboardLayout>
    <StickyFooter />
  </>
);

export { PageLayout };
